import { render, staticRenderFns } from "./SupplierAgents.vue?vue&type=template&id=1797d088&"
import script from "./SupplierAgents.vue?vue&type=script&lang=js&"
export * from "./SupplierAgents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports